import React, {useEffect} from 'react';
import {OrdersSadanContext} from "./OrdersSadanContext"
import objectDataHolder from "../Hooks/ObjectDataHolder";
import axios from "axios";
import {prefixUrl} from "../../utils/utilsData";
import FactorKolOrderSadan from "./FactorKolOrderSadan/FactorKolOrderSadan";
import FactorJozOrderSadan from "./FactorJozOrderSadan/FactorJozOrderSadan";
import './style.scss'
import {useLocation, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import utilsFunction from "../../utils/utilsFunction";
import {calculateSumOfRowOrderSadan} from "./FactorJozOrderSadan/functions";
import {usePrompt} from "../../Hooks/usePrompt";

export const initialSetData = {
  reload: 1,
  customerName: "",
  description: "",
  tableData: [],
  mode: "add",
  customerId: 0,
  addressId: 0,
  paymentType: "online",
  paymentDate: "",
  paymentTime: "",
  paymentCode: "",
  submitDate: "",
  sendPrice: "0",
  discountCode:"",
  discountPrice:"0",
}

function OrdersSadan() {

  const [data, setData] = objectDataHolder(initialSetData)

  const navigateTo = useNavigate()
  const myLocation = useLocation()
  const getData = async () => {

    if (myLocation?.state?.id) {

      const URI = prefixUrl() + `/cartTable/?request=cartSubmittedData&orderId=` + myLocation?.state?.id
      const res = await axios.get(URI)

      if (res?.data?.status) {

        let tableData = res?.data?.data?.tableData;

        tableData = utilsFunction.addRowIdToTable(tableData)
        tableData = utilsFunction.addUniqIdToTable(tableData)

        // توی دیتا بیس اینجوری ذخیره میشه. پس منم مجبورم اینجوری  کار کنم که تغییر بدم
        tableData = tableData.map(v => {
          const row = {...v}
          row.mustICalculateTotalWeight = row.mustICalculateTotalWeight === "1"
          return row
        })

        tableData = calculateSumOfRowOrderSadan(tableData)
        setData({...res?.data?.data, tableData})
      } else {
        toast?.error(res?.data?.message)
        navigateTo(-1)
      }
    }
  }

  useEffect(() => {
    void getData()
  }, []);

  const hasUnsavedChanges = data.mode === 'add' && (data?.tableData?.length > 0 || !!data?.customerName || !!data?.description);
  usePrompt("اطلاعات ذخیره نشده ای وجود دارد. آیا از خروج اطمینان دارید؟", hasUnsavedChanges);

  return (<OrdersSadanContext.Provider value={{data, setData}}>
    <div className={'orders__sadan'}>
      <div
        className={'width__200 bg__white height__90vh rounded'}><FactorKolOrderSadan/></div>
      <div className={'width100 bg__white height__90vh rounded   mx-3'}><FactorJozOrderSadan/></div>

    </div>

  </OrdersSadanContext.Provider>);
}

export default OrdersSadan;